import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reduxForm, change, formValueSelector,untouch } from 'redux-form';
import Logger from '../../util/Logger';
import * as clientDetailsActions from '../../actions/clientDetailsActions';
import { jobDetailsForm } from '../../constants/FormConstants';
import JobDetailsForm from '../jobdetails/JobDetailsForm';
import { bindActionCreators } from 'redux';

const JobDetailsFormContainer = ({initialValues,jobType,onSubmit,isSubmitting}) => {
 //const state = useSelector((state)=>state)
  const dispatch = useDispatch();
  const currentJob = useSelector((state) => state.currentJob);
  const clientDetails = useSelector((state) => state.clientDetails);
  const referenceData = useSelector((state) => state.referenceData);
  //const initialValues = props.initialValues;
  const areaId = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'areaId'))// formValues(props.state, 'areaId');
  const treatmentType = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'treatmentDetails.treatmentTypeId'));//currentJob?currentJob.treatmentDetails.treatmentTypeId:null//formValues(props.state, 'treatmentDetails.treatmentTypeId');
  const technicianId = useSelector((state) =>formValueSelector(jobDetailsForm)(state, 'technicianId'))//currentJob?currentJob.technicianId:useSelector((state) => formValueSelector(jobDetailsForm)(state, 'technicianId'));//formValueSelector(props.state, 'technicianId');
  const selectedCommodity = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'treatmentTypeDetails.commodity'));//currentJob?currentJob.treatmentTypeDetails.commodity:null//formValues(props.state, 'treatmentTypeDetails.commodity');
  const selectedStandard = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'treatmentDetails.standardId'));//currentJob?currentJob.treatmentDetails.standardId:null//formValues(props.state, 'treatmentDetails.standardId');
  const containerType = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'treatmentDetails.containerTypeId'));//currentJob?currentJob.treatmentDetails.containerTypeId:null//formValues(props.state, 'treatmentDetails.containerTypeId');
  const location = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'location'));//formValues(props.state, 'location');
  const selectedDestination = useSelector((state) => formValueSelector(jobDetailsForm)(state, 'treatmentTypeDetails.destination'));//currentJob?currentJob.treatmentTypeDetails.commodity:null//formValues(props.state, 'treatmentTypeDetails.commodity');
  
  const actions = bindActionCreators(
    {
      change, // include the change action her
      ...clientDetailsActions,
      untouch
    },
    dispatch
  );
 
  return (
    <JobDetailsForm
      {...referenceData}
     // {...props}
      //dispatch={props.dispatch}
     // referenceData={referenceData}
     isSubmitting={isSubmitting}
     onSubmit={onSubmit}
    jobType={jobType}
      currentJob={currentJob}
      clientDetails  ={clientDetails}
      marking={[]}
      areaId={areaId}
      treatmentType={treatmentType}
      technicianId={technicianId}
      selectedCommodity={selectedCommodity}
      selectedStandard={selectedStandard}
      selectedDestination={selectedDestination}
      containerType={containerType}
      location={location}
      initialValues ={initialValues}
      actions={actions}
      changeFieldValue={(field, value) => dispatch(change(jobDetailsForm, field, value))}
      onSubmitFail={onSubmitFail}
      untouchField={(field) => dispatch(untouch(jobDetailsForm, field))} 
    />
  );
};
const onSubmitFail = (errors, dispatch, submitError) => {
  Logger.error(
    'We were unable to save the changes, please review the fields in red and try again.',
    submitError,
    'Job not saved',
  );
};
export default reduxForm({
  form: jobDetailsForm,
  enableReinitialize: true,
})(JobDetailsFormContainer);
